<template>
  <div class="star-rating" @click.stop>
    <div
      v-for="(star, index) in totalStars"
      :key="index"
      class="star-item"
      :class="{
        'star-active': index < Math.floor(currentValue),
        'star-half':
          index === Math.floor(currentValue) && currentValue % 1 !== 0,
      }"
      @click="handleStarClick(index + 1)"
      @mouseenter="handleMouseEnter(index + 1)"
      @mouseleave="handleMouseLeave"
    >
      <img :src="getStarSrc(index)" :alt="`star-${index}`" class="star-img" />
    </div>
  </div>
</template>

<script>
export default {
  name: "StarRating",
  props: {
    // v-model 绑定值
    value: {
      type: Number,
      default: 0,
      validator: (val) => val >= 0,
    },
    // 总星数
    totalStars: {
      type: Number,
      default: 5,
      validator: (val) => val > 0,
    },
    // 是否只读
    readonly: {
      type: Boolean,
      default: false,
    },
    // 是否允许半星
    allowHalf: {
      type: Boolean,
      default: false,
    },
    // 自定义星星图片
    starImg: {
      type: Object,
      default: () => ({
        full: require("@/assets/images/questionnaire/1_2.svg"), // 全星
        // half: require("@/assets/star-half.png"), // 半星
        empty: require("@/assets/images/questionnaire/1_1.svg"), // 空星
      }),
    },
    // 星星大小（px）
    starSize: {
      type: Number,
      default: 32,
    },
    // 星星间距（px）
    gap: {
      type: Number,
      default: 8,
    },
  },
  data() {
    return {
      hoverValue: 0, // 鼠标悬停值
      isHover: false, // 是否悬停
    };
  },
  computed: {
    // 当前显示值（优先悬停值，否则绑定值）
    currentValue() {
      return this.isHover ? this.hoverValue : this.value;
    },
  },
  methods: {
    // 点击星星
    handleStarClick(score) {
      if (this.readonly) return;
      // 半星处理
      const finalScore =
        this.allowHalf && score === this.value ? score - 0.5 : score;
      this.$emit("input", finalScore);
      this.$emit("change", finalScore);
    },
    // 鼠标进入
    handleMouseEnter(score) {
      if (this.readonly) return;
      this.isHover = true;
      this.hoverValue = score;
      this.$emit("change", score);
    },
    // 鼠标离开
    handleMouseLeave() {
      if (this.readonly) return;
      this.isHover = false;
      this.hoverValue = 0;
    },
    // 获取对应星星图片
    getStarSrc(index) {
      const current = this.currentValue;
      // 全星
      if (index < Math.floor(current)) {
        return this.starImg.full;
      }
      // 半星
      if (
        this.allowHalf &&
        index === Math.floor(current) &&
        current % 1 !== 0
      ) {
        return this.starImg.half;
      }
      // 空星
      return this.starImg.empty;
    },
  },
};
</script>

<style scoped>
.star-rating {
  width: 100%;
  display: flex;
  align-items: center;
  /* gap: v-bind("gap + 'px'"); */
  justify-content: space-between;
}

.star-item {
  cursor: pointer;
  transition: transform 0.2s ease;
}

.star-item:hover {
  transform: scale(1.1);
}

.star-img {
  width: v-bind("starSize + 'px'");
  height: v-bind("starSize + 'px'");
  object-fit: contain;
  display: block;
}

/* 只读状态去掉hover效果 */
.star-rating .star-item[readonly] {
  cursor: default;
  transform: none;
}
</style>



// WEBPACK FOOTER //
// src/components/StarRating/index.vue